import { render, staticRenderFns } from "./combineRAndP.vue?vue&type=template&id=212e63c8&scoped=true&"
import script from "./combineRAndP.vue?vue&type=script&lang=js&"
export * from "./combineRAndP.vue?vue&type=script&lang=js&"
import style0 from "./combineRAndP.vue?vue&type=style&index=0&id=212e63c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e63c8",
  null
  
)

component.options.__file = "combineRAndP.vue"
export default component.exports